import { Controller } from "@hotwired/stimulus"

// Action sheet for a training plan card: opens a centred modal with the plan
// actions, and hands off to another modal (the delete confirmation) without
// leaving two dialogs stacked on top of each other.
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  // Closes this sheet and opens the dialog named by data-next-modal-id.
  openNext(event) {
    const id = event.currentTarget.dataset.nextModalId
    this.dialogTarget.close()
    document.getElementById(id)?.showModal()
  }
}
